const actions = {
  SET_STATE: 'place/SET_STATE',
  REFRESH_ERRORS: 'place/REFRESH_ERRORS',
  ALL: 'place/ALL',
  FETCH_ALL: 'place/FETCH_ALL',
  DETAILS: 'place/DETAILS',
  ADD: 'place/ADD',
  EDIT: 'place/EDIT',
  REMOVE: 'place/REMOVE'
};

export default actions
